export default __webpack_public_path__ + "static/profile-card-jim-e5154337833874a607586310a3c1530d.jpg";